module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_path.js
// module id = 672
// module chunks = 1 2 3